import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon, DownloadIcon, MailIcon, PlayCircleIcon } from 'lucide-react';
import { PRICES } from '../data/funnel';
import { formatUsd } from '../utils/currency';
import { useOrder } from '../contexts/OrderContext';
import { CheckoutSteps } from '../components/CheckoutSteps';
export function ThankYouPage() {
  const {
    buyerName,
    buyerEmail,
    hasBump,
    hasMasterclass,
    total
  } = useOrder();
  const firstName = buyerName.split(' ')[0] || 'dueño';
  const items = [{
    title: 'Protocolo de Biohacking — Plan de 30 días',
    meta: 'PDF · 84 páginas',
    price: PRICES.blueprint,
    icon: DownloadIcon
  }, ...(hasBump ? [{
    title: 'El Interruptor de Dieta Natural',
    meta: 'PDF · guía de transición',
    price: PRICES.bump,
    icon: DownloadIcon
  }] : []), ...(hasMasterclass ? [{
    title: 'Masterclass en Video: Spine-Shield',
    meta: 'Video · 60 min',
    price: PRICES.masterclass,
    icon: PlayCircleIcon
  }] : [])];
  return <main className="w-full bg-cream pb-24" data-id="element-310" data-mp="3vtc13cgdmrdm">
      <header className="border-b border-navy-deep/10 bg-paper" data-id="element-311" data-mp="3vsiohuuql7nk">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-between gap-3 px-5 py-3.5" data-id="element-312" data-mp="4eeenxpsw294">
          <span className="font-display text-base font-bold text-navy-deep" data-id="element-313" data-mp="9e937um3sfr0">
            Protocolo de Biohacking
          </span>
          <CheckoutSteps current={3} data-id="element-314" data-mp="ebiyhqw6blmr" />
        </div>
      </header>

      <div className="mx-auto max-w-4xl px-5 pt-12" data-id="element-315" data-mp="jbdta5j2kvd3">
        <CheckCircle2Icon className="h-10 w-10 text-navy-soft" data-id="element-316" data-mp="j9swe99a90c2" />
        <h1 className="mt-4 font-display text-[1.75rem] font-bold leading-tight text-navy-deep sm:text-[2.4rem]" data-id="element-317" data-mp="nch7knlgyjc7">
          Listo, {firstName}. Tu protocolo ya es tuyo.
        </h1>
        <p className="mt-3 max-w-2xl text-base leading-relaxed text-navy/70" data-id="element-318" data-mp="2p4c5m0esypby">
          Enviamos tus accesos a{' '}
          <strong className="font-semibold text-navy-deep" data-id="element-319" data-mp="3sgu93ijgjy2e">
            {buyerEmail || 'tu correo registrado'}
          </strong>
          . Empieza por el bloque de columna: son 7 minutos hoy mismo.
        </p>

        <section className="mt-9 rounded-xl border border-navy-deep/10 bg-paper p-6 sm:p-7" data-id="element-320" data-mp="5cmsv1n0be90">
          <h2 className="text-xs font-semibold uppercase tracking-[0.14em] text-navy/50" data-id="element-321" data-mp="18ovowh8sdil">
            Tus materiales
          </h2>
          <ul className="mt-4 divide-y divide-navy-deep/10" data-id="element-322" data-mp="f76fij4115v8">
            {items.map(item => <li key={item.title} className="flex flex-wrap items-center gap-4 py-4" data-id="element-323" data-mp="a8221ga2klz3">
                <item.icon className="h-5 w-5 shrink-0 text-gold" data-id="element-324" data-mp="oy9glkwyhkui" />
                <div className="min-w-0 flex-1" data-id="element-325" data-mp="k10uj98oswnz">
                  <p className="font-semibold leading-snug text-navy-deep" data-id="element-326" data-mp="k2bzvdhs6ch7">{item.title}</p>
                  <p className="text-xs text-navy/55" data-id="element-327" data-mp="xxeb8g5ecu1e">{item.meta}</p>
                </div>
                <button type="button" className="rounded-lg border border-navy-deep/15 px-4 py-2 text-sm font-semibold text-navy-deep transition-colors duration-150 ease-out hover:bg-cream" data-id="element-328" data-mp="sykwkkediwzn">
                  Abrir
                </button>
              </li>)}
          </ul>
          <div className="mt-4 flex items-baseline justify-between border-t border-navy-deep/10 pt-4" data-id="element-329" data-mp="17mtmv6rwr3m2">
            <span className="text-sm text-navy/60" data-id="element-330" data-mp="tvg4hw5qkbsm">Total pagado</span>
            <span className="font-display text-2xl font-bold text-navy-deep" data-id="element-331" data-mp="tu50pwcaj41i">
              ${formatUsd(total)}
            </span>
          </div>
        </section>

        <section className="mt-8 grid gap-5 sm:grid-cols-3" data-id="element-332" data-mp="jzd3wuqj8l7s">
          {[{
          step: 'Hoy',
          title: 'Haz la rutina de columna',
          text: 'Página 12 del protocolo. 7 minutos, sin equipo.'
        }, {
          step: 'Día 2',
          title: 'Audita el plato',
          text: 'Retira los 3 ingredientes de la lista roja y anota la reacción.'
        }, {
          step: 'Día 7',
          title: 'Registra el progreso',
          text: 'Usa el checklist imprimible para comparar movilidad y piel.'
        }].map(s => <div key={s.step} className="flex h-full flex-col rounded-xl border border-navy-deep/10 bg-paper p-5" data-id="element-333" data-mp="3q9qevdlv9qnj">
              <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-334" data-mp="3lboxcx439ze6">
                {s.step}
              </span>
              <h3 className="mt-2 font-display text-base font-bold text-navy-deep" data-id="element-335" data-mp="3bby1os3sleci">{s.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-navy/65" data-id="element-336" data-mp="37ambolh0ar3s">{s.text}</p>
            </div>)}
        </section>

        <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 rounded-xl bg-navy-deep px-6 py-5 text-paper" data-id="element-337" data-mp="19jtdnrpez172">
          <MailIcon className="h-5 w-5 text-gold" data-id="element-338" data-mp="15jrblhfro5r9" />
          <p className="min-w-0 flex-1 text-sm leading-relaxed text-gold-pale" data-id="element-339" data-mp="2nh4d3u5lkeib">
            Si el correo no llega en 10 minutos, revisa Promociones o escríbenos a
            soporte@frenchielongevity.com.
          </p>
          <Link to="/retargeting" className="text-sm font-semibold text-paper underline decoration-gold/60 underline-offset-4 transition-colors duration-150 ease-out hover:text-gold-light" data-id="element-340" data-mp="2x6fltfoknh5o">
            Ver plan de retargeting
          </Link>
        </div>
      </div>
    </main>;
}